import React from 'react';
import { defaultTemplate } from 'core/hoc';
import CreatableSelect from 'react-select/creatable';
import { translate } from 'core/utils';

const CustomCreateableSelectTemplate = ({ onChange, value, label, format }) => {
	const [inputValue, setInputValue] = React.useState('');
	const [isInvalidEmailFormat, setIsInvalidEmailFormat] = React.useState(false);

	return (
		<div>
			<label className="form__label">{label}</label>
			{isInvalidEmailFormat && (
				<div style={{ fontSize: '0.8rem' }} className="type--color--warning">
					{translate('CUSTOMCREATEABLESELECT.INVALIDEMAILFORMAT')}
				</div>
			)}
			<CreatableSelect
				onChange={value => onChange(value)}
				onInputChange={newValue => {
					if (isInvalidEmailFormat) {
						setIsInvalidEmailFormat(false);
					}
					setInputValue(newValue);
				}}
				value={value}
				inputValue={inputValue}
				isMulti
				onKeyDown={e => {
					if (e.key === 'Enter') {
						e.preventDefault(); // prevents the form from submitting
						if (!inputValue) return;

						if (format && !format.test(inputValue)) {
							setIsInvalidEmailFormat(true);
							return;
						}

						onChange([...value, { label: inputValue, value: inputValue }]);
						setInputValue('');
					}
				}}
				menuIsOpen={false}
				isClearable
				components={{
					DropdownIndicator: null,
				}}
				placeholder="Type and press enter to add email"
				styles={{
					control: (provided, state) => ({
						...provided,
						boxShadow: 'none',
						borderWidth: '0px 0px 2px 0px',
						borderStyle: 'solid',
						borderColor: state.isFocused ? '#4cb5cd' : '#D5D5D5',
						'&:hover': {
							boxShadow: 'none',
							cursor: 'text',
						},
					}),
					multiValueRemove: provided => ({
						...provided,
						cursor: 'pointer',
					}),
					clearIndicator: provided => ({
						...provided,
						cursor: 'pointer',
					}),
				}}
			/>
		</div>
	);
};

export default defaultTemplate(CustomCreateableSelectTemplate);
